import { useState } from 'react';
import { supabase } from '../../../../supabase';

export default function useProjectLogic({ getNodes, getEdges, funnelId, getSettingsFunnel }) {
  const [isSaving, setIsSaving] = useState(false);
  const [funnel_real, setFunnel_real] = useState(null);
  const [settings_real, setSettings_real] = useState(null);
  async function handleSave() {
    setIsSaving(true);
    try {
      // Prepare data to save
      const nodes = getNodes();
      const edges = getEdges();
      const settingsFunnel = getSettingsFunnel();

      
      console.log(settingsFunnel);
      const updatedSteps = nodes.map(node => ({
        ...node.data,
        id: node.id,
        position: node.position,
      }));

      // Update action/target/targets according to edges
      const edgeMap = {};
      edges.forEach(edge => {
        const key = edge.sourceHandle || edge.source;
        if (!edgeMap[key]) edgeMap[key] = [];
        edgeMap[key].push(edge.target);
      });


      const positionStartStep = updatedSteps.find(step => step.id === 'start-step');
      if(positionStartStep){
     
        settingsFunnel.startStep = {
          ...settingsFunnel.startStep,
          position: positionStartStep.position
        };
      }
      

      // Remove all nodes whose id is 'start-step'
      const filteredSteps = updatedSteps.filter(step => step.id !== 'start-step');
 

      filteredSteps.forEach(step => {
        (step.blocks || []).forEach(block => {
          if (block.type === 'quiz') {
            (block.options || []).forEach(option => {
              const targets = edgeMap[option.id];
              if (targets && targets.length > 0) { 
                // Salva como array (preferencial), e compatível com single target
                option.targets = targets;
                option.target = targets[0]; // compatibilidade
                option.action = { type: 'step', step: targets[0] };
              } else {
                option.targets = [];
                option.target = null;
                option.action = null;
              }
            });
          }
          if (block.type === 'button') {
            const targets = edgeMap[block.id];
            if (targets && targets.length > 0) { 
              block.targets = targets;
              block.target = targets[0];
              block.action = { type: 'step', step: targets[0] };
            } else {
              block.targets = [];
              block.target = null;
              block.action = null;
            }
          }
          if (block.type === 'loading') {
            const targets = edgeMap[block.id];
            if (targets && targets.length > 0) { 
              block.targets = targets;
              block.target = targets[0];
              block.action = { type: 'step', step: targets[0] };
            } else {
              block.targets = [];
              block.target = null;
              block.action = null;
            }
          }
        });
      });
 
      let funnel_real = JSON.stringify(filteredSteps);
      let settings_real = JSON.stringify(settingsFunnel);
      setFunnel_real(funnel_real);
      setSettings_real(settings_real);
      // Save to Supabase
      const { error } = await supabase
        .from('funnels')
        .update({ funnel: JSON.stringify(filteredSteps), settings: JSON.stringify(settingsFunnel), script: settingsFunnel.script })
        .eq('uuid', funnelId);

      if (error) {
        alert('Erro ao salvar: ' + error.message);
        console.error('Save error:', error);
      } else {
       
      }
    } finally {
      setIsSaving(false);
      return {funnel_real, settings_real};
    }
  }

  return {
   
    handleSave,
    isSaving,
  };
}
